
(function () {
	'use strict';

	angular.module('documentHearingFieldsModule', [])
		.controller("DocumentHearingFieldsController", documentHearingFieldsController);

	documentHearingFieldsController.$inject = ['$http', '$sce', '$timeout', '$location', '$scope', '$rootScope', '$state', '$anchorScroll',
		'documentService', 'anchorService', 'documentContentsSearchService', 'resizeService', '$stateParams', 'folderService', 'localStorageService', 'configService'];

	function documentHearingFieldsController($http, $sce, $timeout, $location, $scope, $rootScope, $state, $anchorScroll,
		documentService, anchorService, documentContentsSearchService, resizeService, $stateParams, folderService, localStorageService, configService) {

		var vm = this;

		vm.documentInformation = {};
		vm.originalData = {};
		vm.fieldId = -1;
		vm.currentData = {};
		vm.oldData = {};
		vm.highlights = {
			highlightText: '',
			currentIndex: 0,
			totalFound: 0
		};

		vm.loginUserId = user.userId;
		var urlParams = $location.url().split('/');
		vm.isEmbedUrl = false;
		vm.typeHideHeader = false;
		vm.documentId = $stateParams.documentId;
		if (urlParams != null && urlParams.length > 0) {
			vm.isEmbedUrl = urlParams[1] == 'embed';
			if (vm.isEmbedUrl) {
				vm.fieldId = urlParams[5];
				vm.typeHideHeader = urlParams.length == 7 ? (urlParams[6] == '1') : false;
				vm.documentId = urlParams[3];
			}
		}

		vm.isShowMetadata = configService.getBool(HandbookConfiguration.MetadataEnabled);
		vm.isShowMetatagTab = configService.getBool(HandbookConfiguration.ShowMetatagTab);
		vm.publishedVersion = configService.getBool(HandbookConfiguration.PublishedVersion);
		vm.showContent = showContent;
		vm.clearActive = clearActive;
		vm.searchAndHighlightText = searchAndHighlightText;
		vm.navForward = navForward;
		vm.navBackward = navBackward;

		vm.focusItem = focusItem;
		vm.goBackDocumentHearing = goBackDocumentHearing;
		vm.editCommentField = editCommentField;
		vm.saveCommentField = saveCommentField;
		vm.editCommentDraf = editCommentDraf;
		vm.deleteCommentField = deleteCommentField;
		vm.goBackDocumentHearing = goBackDocumentHearing;
		vm.printPDF = printPDF;
		vm.getNextSearchResultByEnter = getNextSearchResultByEnter;

		vm.isFloatTitle = $(window).height() > HandbookConfiguration.DocumentTitleScreenHeight ? true : false;

		vm.clickChangeTab = clickChangeTab;
		const listTabCanChange = ['document-about', 'document-searchincontent', 'document-metadata'];
		vm.documentCKVersion = CkVersion.CK4;
		vm.ckVersion = { 'CK4': CkVersion.CK4, 'CK5': CkVersion.CK5 };

		initialize();

		function initialize() {

			processEmbedUrl();
			//check and resize the view
			resizeService.resizeView();

			let tabState = localStorageService.getItem('DocumentTabState');
			if (tabState && listTabCanChange.includes(tabState)) {
				angular.element('#document-top-menu-identifier').css('top', '0px');
				angular.element('#document-content-identifier').css('top', '0px');
			}
			getDocument();
		};

		function processEmbedUrl() {
			if (vm.isEmbedUrl) {
				if (vm.typeHideHeader) {
					angular.element('#documentHeader1Container').hide();
					angular.element('#fieldTitle').hide();
				}
			}
		}

		function getDocument() {
			if (vm.isShowMetadata && vm.isShowMetatagTab) {
				getMetadataTab();
			}
			vm.currentDataPromise =
				$http.get(handbookRequests.GetDocumentInformationForHearingRequest, { params: { 'documentId': vm.documentId } })
				.then(function (result) {
						if (result.data.hidden) {
							showMessageError(globalResources.NoAccessDocument, '632');
							return;
						}
						createTooltipsRelatedDocument(result.data);
						vm.oldData = result.data;
						vm.documentCKVersion = vm.oldData.isNewCKVersion;

						if (vm.oldData.description) {
							vm.oldData.description = $sce.trustAsHtml(vm.oldData.description.replace(new RegExp(String.fromCharCode(13) + String.fromCharCode(10), 'g'), '<br/>'));
						}
						vm.oldData.nodeType = convertToNodeType(vm.oldData.type);
						if (vm.oldData.fieldContents != null) {
							vm.oldData.fieldContents.forEach(function (fieldContent) {
								if (!vm.oldData.fieldId) {
									vm.oldData.fieldId = fieldContent.fieldId;
								}
								if (fieldContent.content) {
									fieldContent.content = $sce.trustAsHtml(fieldContent.content);
								}
								if (fieldContent.description) {
									fieldContent.description = $sce.trustAsHtml(fieldContent.description);
								}
							});
							updateFields();
						}
						if (vm.isShowMetadata && vm.isShowMetatagTab) {
							vm.oldData.metadatas = angular.copy(vm.metadataList);
							formatMetadata();
						}
						angular.copy(vm.oldData, vm.originalData);
						runServicesAfterInit();

						vm.oldData.documentInformation = angular.copy(vm.oldData);
						vm.oldData.confirmInformation = vm.currentData.confirmInformation;

						vm.oldData.fieldId = $stateParams.fieldId;

						buildDocumentObjectFromCurrentDocument(vm.oldData);

						getHearingData();

						$rootScope.title = globalResources.Handbook + " - " + result.data.documentName;

						calculateMaxHeightOForDocumentContentIdentifierInit()
						return vm.currentData;
					})
					.catch(function (result, status, headers, config) {
						showMessageError(result.data, result.status);
					});
		};

		function showMessageError(message, status) {
			if (!status || status.toString() == '600') {
				vm.errorMessage = globalResources.RequiredPermissionsToReadDocument;
			} else if (status.toString() == '632') {
				vm.errorMessage = globalResources.DocumentDoNotExistOrIsArchived;
			} else if (status.toString() == '633') {
				vm.errorMessage = globalResources.DocumentDoNotExistOrIsArchivedOrNotPublished;
				vm.showDocumentLinkToBackendWhenError = true;
			} else {
				vm.errorMessage = message;
			}
			vm.showError = true;
			vm.currentData.documentId = vm.documentId;

			runErrorServicesAfterInit();
		}

		function runErrorServicesAfterInit() {
			tabStateService.closeOpenedTabIfNoPrivilege(tabStateType.documentTabState);
		}

		function getMetadataTab() {
			$http.get(handbookRequests.GetDocumentMetadataRequest, { params: { 'documentId': $stateParams.documentId } })
				.then(function (result) {
					vm.metadataList = result.data;
				});
		};

		function formatMetadata() {
			if (vm.isShowMetadata && vm.oldData.metadatas && vm.oldData.metadatas.length > 0 && vm.isShowMetatagTab) {
				vm.oldData.metadatas.forEach(function (item) {
					item.nameDisplay = $sce.trustAsHtml(item.registerName + ' - ' + item.registerItemName + ' - ' + item.registerValue);
				});
			}
		}

		function updateFields() {
			if (vm.oldData.relatedAttachments && vm.oldData.relatedAttachments.length > 0) {
				vm.oldData.relatedAttachments.forEach(function (x) {
					x.itemId = x.extraId ? x.extraId : x.itemId;
				});
			}
			var relatedDocumentAll = angular.copy(vm.oldData.relatedDocuments);
			var relatedAttachmentAll = angular.copy(vm.oldData.relatedAttachments);

			vm.oldData.isShowTopBoxContent = false;

			for (var i = 0; i < vm.oldData.fieldContents.length; i++) {
				var fieldContent = vm.oldData.fieldContents[i];
				if (fieldContent.relatedAttachments && fieldContent.relatedAttachments.length > 0) {
					fieldContent.relatedAttachments.forEach(function (x) {
						x.itemId = x.extraId ? x.extraId : x.itemId;
					});
				}
				if (checkShowFieldName(fieldContent)) {
					vm.oldData.isShowTopBoxContent = true;
				}

				var relatedDocuments = fieldContent.relatedDocuments;
				relatedDocumentAll = relatedDocumentAll.concat(relatedDocuments);

				var relatedAttachments = fieldContent.relatedAttachments;
				relatedAttachmentAll = relatedAttachmentAll.concat(relatedAttachments);

				var relatedImageGroups = groupBy(fieldContent.images, function (item) {
					return [item.verticalAlign];
				});
				var relatedBottomImages = [];
				var relatedTopImages = [];
				relatedImageGroups.forEach(function (item) {
					if (item.key == parseInt(E.VerticalAlign.Top)) {
						relatedTopImages = relatedTopImages.concat(item.value.data);
					} else {
						if (item.key == parseInt(E.VerticalAlign.Bottom)) {
							relatedBottomImages = relatedBottomImages.concat(item.value.data);
						}
					}
				});
				fieldContent.relatedTopImages = relatedTopImages;
				fieldContent.relatedBottomImages = relatedBottomImages;
			}
		};

		function getHearingData() {
			$http.get(handbookRequests.GetHearingForFeedbackRequest, {
				params: {
					'entityId': vm.oldData.entityId
				}
			})
				.then(function (response, status, headers, config) {
					if (response.data && response.data.id != null && response.data.id > 0) {
						vm.hearing = response.data;
						if (vm.hearing.description && vm.hearing.description != '') {
							vm.hearing.description = $sce.trustAsHtml(vm.hearing.description.replace(/[\r\n\t]/g, "<br/>"));
						}
						checkMemberHearing();
						if (vm.oldData.approvalStatus == 3) {
							vm.showComment = (!vm.hearing.public && vm.isMemberHearing) || vm.hearing.public;
						} else {
							vm.showComment = false;
							vm.hearingClose = true;
						}
						if (vm.hearingClose) {
							vm.closeHearings = vm.hearing.hearingMembers;
							pubSub.publish(broadcastType.gridDataChanges, { id: 'closeHearing', data: vm.closeHearings }, { isForced: true });
						} else {
							vm.hearings = vm.hearing.hearingMembers;
						}
						vm.preHearingMembers = vm.hearing.preHearingMembers;

						if (!vm.hearingCommentAfterResponse && !vm.isMyAssessment) {
							vm.showComment = false;
						}

						adjustmentHearingComments(vm.hearing.hearingComments, vm.hearing.preHearingComments);
					}
				});
		};

		function checkShowFieldName(fieldContent) {
			if (fieldContent.fieldName != '' && fieldContent.fieldName != undefined && fieldContent.isVisible && !fieldContent.isHideByBooklet) {
				return true;
			}
			return false;
		}

		function adjustmentHearingComments(dataComments, preDataComments) {
			var commentDocuments = [];
			var commentFields = [];
			if (dataComments.length > 0) {
				dataComments.forEach(function (item) {
					if (item.fieldId == null) {
						commentDocuments.push(angular.copy(item));
					} else {
						commentFields.push(angular.copy(item));
					}
				});
			}
			vm.commentDocuments = commentDocuments;

			var preCommentDocuments = [];
			var preCommentFields = [];
			if (preDataComments.length > 0) {
				preDataComments.forEach(function (item) {
					if (item.fieldId == null) {
						preCommentDocuments.push(angular.copy(item));
					} else {
						preCommentFields.push(angular.copy(item));
					}
				})
			}
			vm.preCommentDocuments = preCommentDocuments;

			if ((commentFields != null && commentFields.length > 0) || (preCommentFields != null && preCommentFields.length > 0)) {
				for (var i = 0; i < vm.documentInformation.fieldContents.length; i++) {
					var fieldContent = vm.documentInformation.fieldContents[i];
					fieldContent.commentDocumentText = '';
					if (commentFields != null && commentFields.length > 0) {
						var comments = [];
						commentFields.forEach(function (item) {
							if (fieldContent.fieldId == item.fieldId) {
								comments.push(angular.copy(item));
							}
						});
						fieldContent.comments = comments;
					}
					if (preCommentFields != null && preCommentFields.length > 0) {
						var preComments = [];
						preCommentFields.forEach(function (item) {
							if (fieldContent.fieldId == item.fieldId) {
								preComments.push(angular.copy(item));
							}
						});
						fieldContent.preComments = preComments;
					}

					if (fieldContent.fieldId == $stateParams.fieldId) {
						vm.documentInformation.fieldContent = angular.copy(fieldContent);
					}

				}
			} else {
				for (var i = 0; i < vm.documentInformation.fieldContents.length; i++) {
					var fieldContent = vm.documentInformation.fieldContents[i];
					if (fieldContent.fieldId == $stateParams.fieldId) {
						vm.documentInformation.fieldContent = angular.copy(fieldContent);
					}
				}
			}
		};

		function convertToNodeType(documentType) {
			switch (documentType.toString()) {
				case E.documentTypes.Document:
					return E.nodeTypes.Document;
				case E.documentTypes.LinkDocument:
					return E.nodeTypes.LinkDocument;
				case E.documentTypes.FileDocument:
					return E.nodeTypes.FileDocument;
				case E.documentTypes.ShortcutDocument:
					return E.nodeTypes.ShortcutDocument;
			}
		}

		function setIconForDocument(data) {
			data = data == null ? vm.currentData : data;
			var icon = '';
			switch (data.levelType.toString()) {
				case E.HandbookLevelTypes.Enterprise:
					icon = paths.DocumentLevelTypeEnterprise;
					break;
				case E.HandbookLevelTypes.Regional:
					icon = paths.DocumentLevelTypeRegional;
					break;
				case E.HandbookLevelTypes.Local:
					icon = paths.DocumentLevelTypeLocal;
					break;
				default:
					icon = paths.DocumentLevelTypeEnterprise;
					break;
			}
			data.docIcon = icon;
		}

		function buildDocumentObjectFromCurrentDocument(currentDocument) {
			if (currentDocument) {
				vm.documentInformation = angular.copy(currentDocument.documentInformation);
				vm.currentData = angular.copy(currentDocument.documentInformation);
				setIconForDocument(vm.documentInformation);
				if (vm.currentData.description) {
					vm.currentData.description = $sce.trustAsHtml(vm.currentData.description.toString());
				}
				if (vm.isShowMetadata && vm.currentData.metadatas && vm.currentData.metadatas.length > 0 && vm.isShowMetatagTab) {
					vm.currentData.metadatas.forEach(function (item) {
						item.nameDisplay = $sce.trustAsHtml(item.nameDisplay.toString());
					});
				}
				if (vm.documentInformation) {
					for (var i = 0; i < vm.documentInformation.fieldContents.length; i++) {
						if (vm.documentInformation.fieldContents[i].fieldId == currentDocument.fieldId) {
							vm.fieldId = currentDocument.fieldId;
							vm.currentData.confirmInformation = currentDocument.confirmInformation;
							vm.documentInformation.fieldContents[i].activeField = 'active';
							if (vm.documentInformation.fieldContents[i].fieldName) {
								vm.documentInformation.fieldName = $sce.trustAsHtml(vm.documentInformation.fieldContents[i].fieldName.toString());
							}
							if (vm.documentInformation.fieldContents[i].content) {
								vm.documentInformation.content = $sce.trustAsHtml(vm.documentInformation.fieldContents[i].content.toString());
							}
							vm.documentInformation.relatedDocuments = vm.documentInformation.fieldContents[i].relatedDocuments;
							vm.documentInformation.relatedAttachments = vm.documentInformation.fieldContents[i].relatedAttachments;

							vm.documentInformation.relatedTopImages = vm.documentInformation.fieldContents[i].relatedTopImages;
							vm.documentInformation.relatedBottomImages = vm.documentInformation.fieldContents[i].relatedBottomImages;

							vm.documentInformation.fieldContent = vm.documentInformation.fieldContents[i];
						}
						else {
							vm.documentInformation.fieldContents[i].activeField = '';
						}
					}
				}
				angular.copy(vm.documentInformation, vm.originalData);
			}
		};

		function showContent(fieldItem) {
			vm.clearActive();
			fieldItem.activeField = 'active';
			if (fieldItem.fieldName) {
				vm.documentInformation.fieldName = $sce.trustAsHtml(fieldItem.fieldName);
			}
			if (fieldItem.content) {
				vm.documentInformation.content = $sce.trustAsHtml(fieldItem.content.toString());
			} else {
				vm.documentInformation.content = '';
			}
			vm.documentInformation.fieldContent = angular.copy(fieldItem);

			vm.documentInformation.relatedDocuments = fieldItem.relatedDocuments;
			vm.documentInformation.relatedAttachments = fieldItem.relatedAttachments;
			vm.documentInformation.relatedTopImages = fieldItem.relatedTopImages;
			vm.documentInformation.relatedBottomImages = fieldItem.relatedBottomImages;
			vm.fieldId = fieldItem.fieldId;
			angular.copy(vm.documentInformation, vm.originalData);
			updateLocalAnchors();
		};

		function clearActive() {
			for (var i = 0; i < vm.documentInformation.fieldContents.length; i++) {
				vm.documentInformation.fieldContents[i].activeField = '';
			}
		};

		function searchAndHighlightText() {
			highlightTextInContent();
			documentContentsSearchService.searchAndHighlightText(vm.highlights);
		};

		function navForward() {
			documentContentsSearchService.navForward(vm.highlights);
		};

		function navBackward() {
			documentContentsSearchService.navBackward(vm.highlights);
		};

		function highlightTextInContent() {
			if (vm.documentInformation.content != undefined) {
				angular.copy(vm.originalData, vm.documentInformation);
				vm.documentInformation.content = documentContentsSearchService.searchAndHighlight(vm.documentInformation.content, vm.highlights.highlightText);
			}
		};

		function updateLocalAnchors() {
			$timeout(function () {
				var domContent = angular.element('div.contentWithLayout');
				anchorService.updateLocalAnchors(domContent, true);
				scrollToAnchorIfExists();
			});
		}

		function scrollToAnchorIfExists() {
			var hash = $location.hash();
			if (hash != '') {
				$anchorScroll();
			}
		}

		function runServicesAfterInit() {
			updateLocalAnchors();
		}

		function checkMemberHearing() {
			if (vm.hearing.hearingMembers.length > 0) {
				vm.hearing.hearingMembers.forEach(function (item) {
					if (item.employeeId == vm.loginUserId) {
						vm.isMyAssessment = !item.hearingResponse && vm.currentData.approvalStatus == 3;
						vm.isMemberHearing = true;
					}
				})
			}
		};

		function focusItem(itemId) {
			setTimeout(function () {
				angular.element('#' + itemId).show();
				angular.element('#' + itemId).focus();
			}, 0);
		};

		function goBackDocumentHearing() {
			$state.go(handbookActions.HearingAction, { documentId: vm.documentId });
		}

		function saveCommentField(fieldContent, isDraft) {
			var request = {
				entityId: vm.oldData.entityId,
				hearingsId: vm.hearing.id,
				comment: fieldContent.commentDocumentText,
				isDraft: isDraft,
				fieldId: fieldContent.fieldId
			};
			$http.post(handbookRequests.CreateHearingCommentRequest, request)
				.success(function (data, status, headers, config) {
					updateCommentsInformation(fieldContent, data);
					fieldContent.comments = data;
					fieldContent.commentDocumentText = '';
				})
				.error(function (data, status, headers, config) {
					vm.hearingClose = true;
				});
		};

		function editCommentField(comment, fieldContent, isDraft) {
			var request = {
				entityId: vm.oldData.entityId,
				id: comment.id,
				hearingsId: vm.hearing.id,
				comment: comment.commentDocumentText,
				isDraft: isDraft,
				fieldId: fieldContent.fieldId
			};
			$http.post(handbookRequests.UpdateHearingCommentRequest, request)
				.success(function (data, status, headers, config) {
					updateCommentsInformation(fieldContent, data);
					fieldContent.comments = data;
				})
				.error(function (data, status, headers, config) {
					vm.hearingClose = true;
				});
		};

		function updateCommentsInformation(fieldContent, data) {
			for (var i = 0; i < vm.documentInformation.fieldContents.length; i++) {
				if (vm.documentInformation.fieldContents[i].fieldId == fieldContent.fieldId) {
					vm.documentInformation.fieldContents[i].comments = data;
					break;
				}
			}
		}

		function deleteCommentField(comment, comments) {
			var isConfirm = confirm(globalResources.DeleteHearingCommentConfirmMessage);
			if (isConfirm) {
				var request = {
					entityId: vm.currentData.entityId,
					id: comment.id
				};
				$http.post(handbookRequests.DeleteHearingCommentRequest, request)
					.success(function (data, status, headers, config) {
						comments.splice($.inArray(comment, comments), 1);
						for (var i = 0; i < vm.documentInformation.fieldContents.length; i++) {
							if (vm.documentInformation.fieldContents[i].fieldId == vm.documentInformation.fieldContent.fieldId) {
								vm.documentInformation.fieldContents[i].comments.splice($.inArray(comment, vm.documentInformation.fieldContents.comments), 1);
								break;
							}
						}
					})
					.error(function (data, status, headers, config) {
						vm.hearingClose = true;
					});
			}
		};

		function editCommentDraf(comment) {
			comment.showCommentDocument = true;
			vm.focusItem('txtUpdateComment');
			comment.commentDocumentText = comment.comment.replace(new RegExp('<br/>', 'g'), '\n');
		}

		function printPDF() {
			window.open(String.format("/Printing/PrintHearingFeedback?documentId={0}", vm.documentId));
		};

		function anchorClick(hash) {
			if (vm.documentInformation.fieldContents.length == 1)
				return;
			var existedAnchor = false;
			var domContent = angular.element('div.contentWithLayout');
			angular.forEach(domContent.find('a[name]'), function (tag) {
				if (hash.hash.indexOf(tag.attributes.name.value) != -1) {
					existedAnchor = true;
				}
			});
			if (existedAnchor)
				return;

			var field = null;
			for (var i = 0; i < vm.documentInformation.fieldContents.length; i++) {
				var fieldContent = vm.documentInformation.fieldContents[i];
				if (fieldContent.fieldId == vm.fieldId || !fieldContent.content) {
					continue;
				}

				var div = document.createElement('div');
				div.innerHTML = fieldContent.content;
				domContent = angular.element(div);
				angular.forEach(domContent.find('a[name]'), function (tag) {
					if (hash.hash.indexOf(tag.attributes.name.value) != -1) {
						existedAnchor = true;
					}
				});
				if (existedAnchor) {
					field = fieldContent;
					break;
				}
			}
			if (field != null) {
				showContent(field);
			}
		}

		function getNextSearchResultByEnter(keyEvent) {
			if (keyEvent.which == 13) {
				navForward();
			}
		}

		$scope.$on('anchorclick', function (e, target) {
			anchorClick(target);
		});

		function clickChangeTab() {
			let tabStateChange = localStorageService.getItem('DocumentTabState');

			if (!listTabCanChange.includes(tabStateChange)) {
				angular.element('#document-top-menu-identifier').css('top', '65px');
				angular.element('#document-content-identifier').css('top', '65px');
			} else {
				angular.element('#document-top-menu-identifier').css('top', '0px');
				angular.element('#document-content-identifier').css('top', '0px');
			}
		}

		function calculateMaxHeightOForDocumentContentIdentifierInit() {
			let calculateMaxHeight = localStorageService.getItem('DocumentTabState');
			if (!calculateMaxHeight || calculateMaxHeight == 'null' ) {
				if (angular.element('#document-content-identifier')) {
					angular.element('#document-content-identifier').css('maxHeight', `calc(100vh - ${angular.element('#document-content-identifier').position(0).top}px)`);
				}
			}
		}
	};

})();